<script lang="ts" context="module">
    export type Link = [string, string, Link[]?];
</script>

<script lang="ts">
    import { url, isActive, afterPageLoad } from "@roxi/routify";
    import IconImg from "./IconImg.svelte";
    import Menubars from "../icons/MenuBarsIcon.svelte";
    import Mail from "../icons/MailIcon.svelte";
    import LogoSimple from "../icons/logoSimple.svelte";
    import LogoLucy from "../icons/logoLucy.svelte";
    import NavDropdown from "./NavDropdown.svelte";
    import Close from "../icons/CloseIcon.svelte";
    import PhoneLink from "./PhoneLink.svelte";
    import MailLink from "./MailLink.svelte";
    import FacebookIcon from "../icons/FacebookIcon.svelte";
    import XingIcon from "./XingIcon.svelte";
    import LogoIcon from "./LogoIcon.svelte";
    import ArrowRightIcon from "../icons/ArrowRightIcon.svelte";
    import YoutubeIcon from "../icons/YoutubeIcon.svelte";
    import LinkedInIcon from "../icons/LinkedInIcon.svelte";
    import { locale, swapLocale, t } from "../helpers/translation";

    const getLinks: () => Link[] = () => [
        ["./index", $t("menu.page.home")],
        [
            "./loesungen",
            $t("menu.page.loesungen"),
            [
                ["/leitsysteme", $t("menu.page.loesungen.leitsysteme")],
                ["/wachen-und-elw", $t("menu.page.loesungen.wachenelw")],
                [
                    "/einsatznavigation",
                    $t("menu.page.loesungen.einsatznavigation"),
                ],
                [
                    "/sprach-und-datenfunk",
                    $t("menu.page.loesungen.sprachdatenfunk"),
                ],
                [
                    "/digitale-alarmierung",
                    $t("menu.page.loesungen.digitalalarm"),
                ],
                ["/reparaturen", $t("menu.page.loesungen.repair")],
                ["/it", $t("menu.page.loesungen.it")],
            ],
        ],
        [
            "./ueber-uns",
            $t("menu.page.about"),
            [
                ["/niederlassungen", $t("menu.page.about.niederlassungen")],
                ["/unsere-werte", $t("menu.page.about.unserewerte")],
                ["/ueber-uns", $t("menu.page.about.about")],
                ["/management", $t("menu.page.about.management")],
                ["/umwelt", $t("menu.page.about.umwelt")],
                ["/team", $t("menu.page.about.team")],
                ["/partner", $t("menu.page.about.partner")],
                ["/zertifikate", $t("menu.page.about.certificates")],
                ["/verbaende", $t("menu.page.about.verbaende")],
            ],
        ],
        [
            "./aktuelles",
            $t("menu.page.news"),
            [
                ["/termine", $t("menu.page.news.termine")],
                // ["/wir-wachsen", $t("menu.page.news.wirwachsen")],
                ["/news", $t("menu.page.news.news")],
            ],
        ],
        ["./karriere", $t("menu.page.career")],
        // ["./kontakt", $t("menu.page.contact")],
    ];

    $: links = getLinks();

    let darken: boolean = false;
    let hasScrolled: boolean = false;
    let menu = {};
    //prettier-ignore
    const animateMenu = () => {
        hasScrolled = scrollY > 100;
        if (hasScrolled)
        {
            topbar.style.height = "0"
        } 
        else 
        {
            topbar.style.height = topbar.scrollHeight.toString()+"px";
        }
    };

    let scrollY: number;
    let topbar: HTMLElement;

    let showBurgerMenu = false;
    let windowWidth;
    let showSideBar = false;

    $: isMobile = windowWidth < 900;

    $afterPageLoad((page) => {
        if (window.scrollY > 100) (hasScrolled = true), (darken = true);
        showSideBar = false;
        return true;
    });
</script>

<svelte:window
    bind:scrollY
    on:scroll={animateMenu}
    on:load={animateMenu}
    bind:innerWidth={windowWidth}
/>

<header class:hasScrolled class:darken class:isMobile>
    <div id="topbar" bind:this={topbar} class:hide={isMobile}>
        <div class="inner">
            <div id="topbar-standorte">
                {@html $t("menu.topbar.locations")}
            </div>
            <div id="topbar-icons">
                <PhoneLink text="+49 40 682875 0" />
                <MailLink text="kontakt@sinus-nt.de" />
                <a href="https://www.facebook.com/SINUSNT/" target="_blank">
                    <IconImg svg={FacebookIcon} />
                </a>
                <a
                    href="https://www.xing.com/pages/sinusnachrichtentechnikgmbh"
                    target="_blank"
                >
                    <IconImg svg={XingIcon} />
                </a>
                <a
                    href="https://www.youtube.com/channel/UC1a4Tzed7lcrdJAlMu9Ol2Q"
                    target="_blank"
                >
                    <IconImg svg={YoutubeIcon} />
                </a>
                <a
                    href="https://de.linkedin.com/company/sinus-nachrichtentechnik?trk=public_profile_topcard-current-company"
                    target="_blank"
                >
                    <IconImg svg={LinkedInIcon} />
                </a>
            </div>
        </div>
    </div>

    <div id="menubar">
        <div id="menu-logo">
            <a href="/">
                <LogoIcon />
            </a>
        </div>
        <nav
            id="nav"
            on:scroll|stopPropagation|preventDefault
            class:showSideBar
        >
            <div class="inner">
                {#each links as [href, name, submenu]}
                    {#if !submenu}
                        <a
                            class="nav-link"
                            href={$url(href)}
                            class:active={$isActive(href)}
                            ><div class="inner">
                                {name}
                            </div>
                        </a>
                    {:else}
                        <div
                            on:click={() => (menu[href] = true)}
                            class:active={$isActive(href)}
                            class="nav-link"
                        >
                            {name}
                            {#if menu[href]}
                                <NavDropdown
                                    links={submenu}
                                    base={href}
                                    bind:open={menu[href]}
                                    bind:isMobile
                                />
                            {/if}
                        </div>
                    {/if}
                {/each}
                <!-- TODO enable -->
                <a
                    class="nav-link"
                    on:click={() => {
                        swapLocale();
                        links = getLinks();
                    }}
                >
                    <div class="inner">
                        {#if $locale === "de"}
                            <IconImg src="/langs/en.png" />
                        {:else}
                            <IconImg src="/langs/de.png" />
                        {/if}
                    </div>
                </a>
            </div>
            <div id="close-nav" on:click={() => (showSideBar = false)}>
                <Close />
            </div>
        </nav>
        <div id="burger-menu" on:click={() => (showSideBar = true)}>
            <IconImg svg={Menubars} color="white" />
        </div>
        <div id="nav-end" />
    </div>
</header>

<style lang="scss">
    @import "../vars";

    #topbar {
        overflow: hidden;
        transition: height 0.5s;

        &.hide {
            display: none;
        }
        .inner {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.5em 2em;
            font-size: 0.9rem;
            :global(*) {
                color: white;
                font-weight: 300;
            }
            background-color: $green;
            gap: 1em;
        }
        #topbar-standorte {
            word-spacing: 0.5em;
        }
        #topbar-icons {
            > :global(*) {
                margin-left: 1em;
            }
        }
    }

    #menubar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0em 1em;
        transition: 0.5s;
    }
    #menu-logo {
        :global(svg) {
            height: 3em !important;
            width: auto !important;
        }
    }

    #burger-menu,
    #close-nav {
        display: none;
    }

    #nav-end {
        width: 90px;
    }

    $navHeight: 4em;
    #nav {
        > .inner {
            display: flex;
            gap: 2em;
            .nav-link {
                position: relative;
                color: white;
                line-height: $navHeight;
                cursor: pointer;
            }
        }
    }

    header {
        position: fixed;
        z-index: 100;
        top: 0;
        left: 0;
        width: 100%;
        background-color: rgba(black, 0.1);
        transition: 1s;
        &.hasScrolled,
        &.darken {
            background-color: rgba($grayDark2, 0.85);
        }

        &.isMobile {
            #menubar {
                padding: 1em !important;
            }
            #nav {
                position: fixed !important;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba($grayDark2, 0.95);
                > .inner {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    overflow-y: auto;
                    padding: 8em 0;
                    height: 100%;
                    width: 100%;
                    .nav-link {
                        text-align: center;
                    }
                }
                transform: translateX(100%);
                transition: 0.5s;
                &.showSideBar {
                    transform: translateX(0);
                }
            }
            #burger-menu {
                font-size: 2rem;
                cursor: pointer;
                display: block;
            }
            #close-nav {
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 0;
                width: 3em;
                height: 3em;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $yellow;
                :global(svg) {
                    width: 2em;
                    height: 2em;
                }
            }
            #nav-end {
                display: none;
            }

            :global(.nav-link.active) {
                border-bottom: none !important;
            }
        }
    }

    :global(.nav-link.active) {
        color: $yellow !important;
        font-weight: 500;
        border-bottom: 3px solid $yellow;
    }
</style>
